import { PageRoutes } from '@/constants/PageRoutes'
import { ApiStatus, UCenterServices } from 'network'
import { UiUtils } from 'ui-components'
import { useUserInfoStore } from 'store'
import { encryptPassword } from 'utils'
import { useI18n } from 'i18n-utils'

export const useForgetPasswordStore = defineStore('forgetPasswordStore', () => {
  const router = useRouter()
  const loading = ref(false)
  const forgetPasswordCheckResult = ref<ApiResponse.ForgetPasswordCheckResult>()
  const loginCheckResult = ref<ApiResponse.LoginCheckResult>()
  const tempToken = ref('')
  const resetLoading = ref(false)
  const { t } = useI18n()
  const resetForm = ref({
    newPwd: '',
    confirmPwd: '',
  })

  const tokenLogin = ref('')
  const account = ref('')

  const { setUserInfo } = useUserInfoStore()

  const onCancel = () => {
    router.back()
  }

  const setTokenLogin = (_tokenLogin: string) => {
    tokenLogin.value = _tokenLogin
  }

  const setAccount = (_account: string) => {
    account.value = _account
  }
  const setLoginCheckResult = (_loginCheckResult: ApiResponse.LoginCheckResult) => {
    loginCheckResult.value = _loginCheckResult
  }
  const onCheckUniversal = async () => {
    loading.value = true
    const res = await UCenterServices.findPwd({
      loginName: account.value,
      tokenLogin: tokenLogin.value,
    })
    loading.value = false
    if (res.status !== ApiStatus.Success) {
      UiUtils.showError(res.msg)
      return false
    }
    const forgetInfo = res.data.forgetInfo
    if (forgetInfo.authInfo.openEmail === 0 && forgetInfo.authInfo.openMobile === 0 && forgetInfo.authInfo.openGoogle === 0) {
      throw UiUtils.showError(t('账号未完成任何安全验证，无法重置密码，请联系客服'))
    }
    forgetPasswordCheckResult.value = res.data
    // 需要验证
    tempToken.value = res.data.token
    setUserInfo(forgetInfo as unknown as ApiResponse.OnlineUserInfo)
    return true
  }

  const onResetPwd = async () => {
    if (!resetForm.value.newPwd || !resetForm.value.confirmPwd) {
      UiUtils.showError(t('请输入新密码'))
      return false
    }
    if (resetForm.value.newPwd.length < 6) {
      UiUtils.showError(t('密码长度不能小于6位'))
      return false
    }
    if (resetForm.value.newPwd !== resetForm.value.confirmPwd) {
      UiUtils.showError(t('两次输入的密码不一致'))
      return false
    }
    UiUtils.checkLoginPassword(resetForm.value.newPwd)
    resetLoading.value = true
    const res = await UCenterServices.resetPwd({
      token: forgetPasswordCheckResult.value!.token,
      tokenForget: forgetPasswordCheckResult.value!.tokenForget,
      pwd: encryptPassword(resetForm.value.newPwd),
    })
    resetLoading.value = false
    if (res.status === ApiStatus.Success) {
      UiUtils.showSuccess(t('密码重置成功'))
    }
    return res.status === ApiStatus.Success
  }

  const forgetCheckSafetyVerify = async (tokenVerify: string) => {
    loading.value = true
    const res = await UCenterServices.forgetCheckSafetyVerify({
      token: forgetPasswordCheckResult.value!.token,
      tokenVerify,
      tokenForget: forgetPasswordCheckResult.value!.tokenForget,
    })
    loading.value = false
    if (res.status !== ApiStatus.Success) {
      return
    }
    forgetPasswordCheckResult.value = res.data
    if (res.data.status === 3) {
      router.push(PageRoutes.ResetPassword)
    }
  }

  return {
    onCancel,
    onCheckUniversal,
    loading,
    forgetPasswordCheckResult,
    tempToken,
    resetLoading,
    resetForm,
    loginCheckResult,
    onResetPwd,
    forgetCheckSafetyVerify,
    tokenLogin,
    account,
    setTokenLogin,
    setAccount,
    setLoginCheckResult,
  }
})
